export default __webpack_public_path__ + "static/media/menu-dashboard.3b742174.svg";